import formatPrice from 'utils/formatPrice';

const getPaymentValue = ({ payment, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return payment ? formatPrice(payment['Unit Amount']) : '';
};

export default getPaymentValue;



// WEBPACK FOOTER //
// ./src/utils/print/getPaymentValue.js